import {
  ENGINEERPROJECTLIST} from 'actions/engineerProject';
import {reducerPackage} from "../../utils";
export const engineerProjectList = reducerPackage(ENGINEERPROJECTLIST);

